"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gameplay = void 0;
var Gameplay;
(function (Gameplay) {
    Gameplay["TextWithChoicesGameplay001"] = "TextWithChoicesGameplay001";
    Gameplay["TextWithChoicesGameplay002"] = "TextWithChoicesGameplay002";
    Gameplay["TextWithChoicesGameplay003"] = "TextWithChoicesGameplay003";
    Gameplay["FourImageChoicesGameplay001"] = "FourImageChoicesGameplay001";
    Gameplay["FourImageChoicesGameplay002"] = "FourImageChoicesGameplay002";
    Gameplay["FourImageChoicesGameplay003"] = "FourImageChoicesGameplay003";
    Gameplay["FourImageChoicesGameplay004"] = "FourImageChoicesGameplay004";
    Gameplay["FourTextChoicesGameplay001"] = "FourTextChoicesGameplay001";
    Gameplay["FourTextChoicesGameplay002"] = "FourTextChoicesGameplay002";
    Gameplay["FourTextChoicesGameplay003"] = "FourTextChoicesGameplay003";
    Gameplay["FourTextChoicesGameplay004"] = "FourTextChoicesGameplay004";
    Gameplay["AudioWithChoicesGameplay001"] = "AudioWithChoicesGameplay001";
    Gameplay["AudioWithChoicesGameplay002"] = "AudioWithChoicesGameplay002";
    Gameplay["ImageWithChoicesGameplay001"] = "ImageWithChoicesGameplay001";
    Gameplay["ImageWithChoicesGameplay002"] = "ImageWithChoicesGameplay002";
    Gameplay["ImageWithChoicesGameplay003"] = "ImageWithChoicesGameplay003";
    Gameplay["ImageWithChoicesGameplay004"] = "ImageWithChoicesGameplay004";
    Gameplay["ImageWithChoicesGameplay005"] = "ImageWithChoicesGameplay005";
    Gameplay["ImageWithChoicesGameplay006"] = "ImageWithChoicesGameplay006";
    Gameplay["MultipleChoiceSelectionGameplay001"] = "MultipleChoiceSelectionGameplay001";
    Gameplay["FillTheBlankWithMultipleChoiceSelectionGameplay001"] = "FillTheBlankWithMultipleChoiceSelectionGameplay001";
    Gameplay["ComposeTheBlankWithLanguageNumberChoicesGameplay001"] = "ComposeTheBlankWithLanguageNumberChoicesGameplay001";
    Gameplay["VideoWithChoicesGameplay002"] = "VideoWithChoicesGameplay002";
    Gameplay["DiagramGameplay001"] = "DiagramGameplay001";
    Gameplay["DiagramGameplay002"] = "DiagramGameplay002";
    Gameplay["TextWithPeriodicTableChoicesGameplay001"] = "TextWithPeriodicTableChoicesGameplay001";
    Gameplay["TextWithPeriodicTableChoicesGameplay002"] = "TextWithPeriodicTableChoicesGameplay002";
    Gameplay["TextWithElementChoicesGameplay001"] = "TextWithElementChoicesGameplay001";
    Gameplay["ImageWithImageChoicesGameplay001"] = "ImageWithImageChoicesGameplay001";
    Gameplay["TextWithImageChoicesGameplay001"] = "TextWithImageChoicesGameplay001";
    Gameplay["ImageWithNumberChoicesGameplay001"] = "ImageWithNumberChoicesGameplay001";
    Gameplay["FillInWithPeriodicTableChoicesGameplay001"] = "FillInWithPeriodicTableChoicesGameplay001";
    Gameplay["FillInWithNumberChoicesGameplay001"] = "FillInWithNumberChoicesGameplay001";
})(Gameplay || (exports.Gameplay = Gameplay = {}));
